/** 대한항공 */
export const SITE_SKYPASS = 'N2507000011';
